.mainContainer {
  background: linear-gradient(135deg, #8cc6f6, #c3eeda) 0% 0% no-repeat
    padding-box;
}

.adminContent {
  background: rgba(255, 255, 255, 0.7);
}
